import script from "./HomeScreenPanelStartChat.vue?vue&type=script&lang=ts&setup=true"
export * from "./HomeScreenPanelStartChat.vue?vue&type=script&lang=ts&setup=true"

import "./HomeScreenPanelStartChat.vue?vue&type=style&index=0&id=1f53206a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f53206a"]])

export default __exports__